import i18n from 'i18next';

// Its own namespace: the skeleton is in the initial bundle and must not pull the module's copy.
export const NS = 'agent-skills-skeleton';

export const en = {
  list: "Loading the agent's skills",
  editor: 'Loading the skill',
  logs: "Loading the skill's execution log",
  vault: 'Loading secrets and variables',
};
export const es: typeof en = {
  list: 'Cargando las skills del agente',
  editor: 'Cargando la skill',
  logs: 'Cargando el registro de ejecuciones de la skill',
  vault: 'Cargando secretos y variables',
};
export const pt: typeof en = {
  list: 'Carregando as skills do agente',
  editor: 'Carregando a skill',
  logs: 'Carregando o registro de execuções da skill',
  vault: 'Carregando segredos e variáveis',
};

// Guarded so importing this is safe where the i18next singleton isn't initialized (jest).
if (typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('en', NS, en, true, true);
  i18n.addResourceBundle('es', NS, es, true, true);
  i18n.addResourceBundle('pt', NS, pt, true, true);
}
